//@ts-ignore
import DynamicCss from "./DynamicCSS/DynamicCss";
import "@fortawesome/fontawesome-free/css/all.css";
import ErrorBoundary from "./Pages/CustomErrorPage/ErrorBoundary";

// import FormDemo from "./FormDemo/FormDemo";
import "./App.css";
import "./theme.css";

import RoutesComponent from "./Routes/routes.tsx";

import { LoaderContext } from "./Helpers/Context/Context";
import Loader from "./Helpers/Loader/Loader";
import { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

function App() {
  const [loader, setLoader] = useState<boolean>(false);
  const showLoader = () => setLoader(() => true);
  const hideLoader = () => setLoader(() => false);

  const { instance, inProgress } = useMsal();

  useEffect(() => {
    // Handle Azure AD redirect after login
    const checkRedirect = async () => {
      try {
        // Processes the response returned after loginRedirect/loginPopup
        const response = await instance.handleRedirectPromise();

        if (response && response.account) {
          // If a valid account is found → set it as active
          instance.setActiveAccount(response.account);
        } else {
          // If no response (e.g. page reload), check cached accounts
          const accounts = instance.getAllAccounts();

          if (accounts.length > 0) {
            // Set first available cached account as active
            instance.setActiveAccount(accounts[0]);
          }
        }
      } catch (err) {
        console.error("Error in handleRedirectPromise:", err);
      }
    };

    // Run redirect handler only when MSAL is idle (not logging in)
    if (inProgress === InteractionStatus.None) {
      checkRedirect();
    }
  }, [instance, inProgress]);

  return (
    <ErrorBoundary>
      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        {/* <Header />
        <Sidebar /> */}
        <RoutesComponent />
        <div className="main-container"></div>
        {/* <Footer /> */}
        {loader && <Loader />}
      </LoaderContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
